import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  .BaseModal-Content.popup {
    // Change width here. Use "interactive" if using a different variant
    // All changes here will affect the modal as a whole

    width: 620px;
  }

  &.DeleteViewConfirmationModal .BaseModal-Body {
    // Override any Modal styling here! This will be your main target CSS selector
    display: flex;
    flex-direction: column;
    gap: ${spacing(10)};
  }
`
